/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import Menubar from "../MenuBar/MenuBar";

export default ({children}) => {
  return (
    <React.Fragment>
      <Menubar/>
      <div className={"bodyContent"}>{children}</div>
    </React.Fragment>
  );
};
